export default {
  // 搜索区域
  typePlaceholder: '请输入类型（无人机/机器狗/机器人）',
  topicPlaceholder: '请输入主题',
  searchButton: '查询',
  addTopic: '新增主题',

  // 表格列
  typeColumn: '类型',
  topicColumn: '主题',
  createTimeColumn: '创建时间',
  actionColumn: '操作',

  // 表单字段
  typeLabel: '类型',
  topicLabel: '主题',
  typeSelectPlaceholder: '请选择类型',
  topicInputPlaceholder: '例如 thing/product/dog/ROBOT_DOG_006/event',

  // 按钮
  deleteButton: '删除',
  cancelButton: '取消',
  confirmButton: '确定',

  // 验证提示
  typeRequired: '请选择类型',
  topicRequired: '请输入主题',

  // 消息提示
  deleteConfirm: '是否删除 {topic}',
  deleteSuccess: '删除成功',
  addSuccess: '新增成功',

  // 设备类型
  drone: '无人机',
  dog: '机器狗',
  robot: '机器人',

  // 弹窗标题
  addTopicTitle: '新增主题',
}
